<template src="./HomePage.html">

</template>
<script>
import activePath from '../../../mixins/activePath.js';
import 'particlesjs'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'

export default {
  data(){
    return{
      toggleMenu:false,
      isBiometricActive: false,
      isOverviewActive: true,
      isTrainingActive: false,
      isSoftwareActive: false,
      isConsultancyActive: false,
      slideIndex :0,
      scrollPosition: null,
      cardColor:"green",

      logos: [
        {
          title: 'OFAG',
          image: require('@/assets/img/logo/accountant-General.png'),
          link:'http://oagf.gov.ng/'
        },
        {
          title: 'NIBSS',
          image: require('@/assets/img/logo/nibss-logo.png'),
          link:'https://nibss-plc.com.ng/'
        },
        {
          title: 'NIRSAL',
          image: require('@/assets/img/logo/nirsal-main.png'),
          link:'https://nirsal.com/'
        },
        {
          title: 'Federal Ministry of Education',
          image: require('@/assets/img/logo/attestation-logo.png'),
          link:'http://education.gov.ng/'
        },
        {
          title: 'North East Development Commission',
          image: require('@/assets/img/logo/nedc.jpg'),
          link:'https://nedc.gov.ng/'
        },
        {
          title: 'Kogi State Government',
          image: require('@/assets/img/logo/kogi-state.png'),
          link:'https://www.kogistate.gov.ng/'
        },
        {
          title: 'Nigerian Defence Academy',
          image: require('@/assets/img/logo/nda.png'),
          link:'https://www.nda.edu.ng/'
        },
        {
          title: 'Galaxy Backbone',
          image: require('@/assets/img/logo/galaxy-backbone-logo.png'),
          link:'https://galaxybackbone.com.ng/'
        },
        {
          title: 'Federal Mortgage Bank',
          image: require('@/assets/img/logo/mortgage-main.png'),
          link:'https://www.fmbn.gov.ng/'
        },
        
        {
          title: 'Flexisaf Edusoft Limited',
          image: require('@/assets/img/logo/flexisaf-main.png'),
          link:'https://flexisaf.com/'
        },
        
        
      ]
    }
  },
  components: { VueperSlides, VueperSlide },

  methods:{
    // updateColor(){
      // let c1 = document.getElementById('card1');
      // let c2 = document.getElementById('card2');
      // let c3 = document.getElementById('card3');
      // let c4 = document.getElementById('card4');

      // c1.addEventListener('mouseenter', function(){
      //   return "orange"
      //   // console.log(this.cardColor);
        
      //   // "rgba(128, 243, 243, 0.9)";
      // });
      // c2.addEventListener('mouseenter', function(){
      //   this.cardColor = "yellow"
      //   // console.log(this.cardColor);
      //   // "rgba(126, 243, 204, 0.9)";     

      // });
      // c3.addEventListener('mouseover', function(){
      //   this.cardColor = "rgba(248, 167, 167, 0.9)";     
      //   // console.log(this.cardColor);

      // });
      // c4.addEventListener('mouseover', function(){
      //   this.cardColor = "rgba(243, 241, 148, 0.5)";     
      //   // console.log(this.cardColor);
      // });
    // },

    updateScroll() {
      this.scrollPosition = window.scrollY
    },

    // Slide Show
    // Next/previous controls
    plusSlides(n) {
        this.showSlides(this.slideIndex += n);
    },

    // Thumbnail image controls
    currentSlide(n) {
        this.showSlides(this.slideIndex = n);
    },
    // For automatic slider
    showSlides() {
        var i;
        var slides = document.getElementsByClassName("mySlides");
        // var dots = document.getElementsByClassName("dot");
        for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";  
        }
        this.slideIndex++;
        if (this.slideIndex > slides.length) {this.slideIndex = 1}    
        // for (i = 0; i < dots.length; i++) {
        //   dots[i].className = dots[i].className.replace(" active", "");
        // }
        slides[this.slideIndex - 1].style.display = "block";  
        // dots[this.slideIndex-1].className += " active";
        setTimeout(this.showSlides, 7500);
    }
  },
  
  mounted(){
    // let c1 = document.getElementById('card1');
    this.showSlides();
    window.addEventListener('scroll', this.updateScroll);
    // this.updateColor()

  },
  
  destroy() {
    window.removeEventListener('scroll', this.updateScroll)
  },

  mixins:[activePath]  
}
</script>


// WEBPACK FOOTER //
// src/components/views/homepage/HomePage.vue